import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  Renderer2,
} from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';

import { gsap } from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeAnimation } from './utility/animations/router.animation';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
    // Your logic on beforeunload
    this.renderer.addClass(this.document.body, 'fade-out');
  }
  initialized: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private router: Router
  ) {
    gsap.registerPlugin(TextPlugin, ScrollToPlugin, ScrollTrigger);

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // console.warn("event instanceof NavigationStart");
      }
      if (event instanceof NavigationEnd) {
        if (!this.initialized) {
          this.initialized = true;
          this.renderer.removeClass(this.document.body, 'fade-out');
        }
      }
    });
  }
  inverted: boolean = false;
  toggleColor() {
    this.inverted
      ? this.renderer.addClass(this.document.documentElement, 'dark')
      : this.renderer.removeClass(this.document.documentElement, 'dark');
    this.inverted = !this.inverted;
    this.cdRef.detectChanges();
  }
}
